import React from 'react';
import { If } from '../If/If';
import { Container, Title,Text } from './styles';

interface IBadgeTitledProps {
    title?: string;
    text?: string;
    marginLeft?: string;
}

export const BadgeTitled: React.FC<IBadgeTitledProps> = ({
    title,
    text,
    marginLeft
}) => {

    return (
        <Container marginLeft={marginLeft}>
            <If condition={!!title}>
                <Title>{`${title}: `}</Title>
            </If>
            <If condition={!!text}>
                <Text>{text}</Text>
            </If>
        </Container>
    );
}